import React, { useEffect } from 'react'

import { useSubBuilder } from '../../../context/subBuilder/useSubBuilder';
import LoadingBar from '../LoadingBar';
import StepBar from './components/StepBar';

import DateStep from './steps/date';
import Duration from './steps/duration';
import Grind from './steps/grind';
import Quantity from './steps/quantity';
import Roast from './steps/roast';
import Routine from './steps/routine';
import Summary from './steps/summary';
import Who from './steps/who';



const SubBuilder: React.FunctionComponent = () => {
  const { settings, state } = useSubBuilder()

  useEffect(() => {
    const scroll = state.step ? document.querySelector('[data-header]').clientHeight : 0;
    window.scrollTo({ top: scroll, behavior: 'smooth' });
  }, [state.step])

  if (!settings) {
    return <LoadingBar></LoadingBar>
  }

  const stepConfig = settings.steps.summary
  const productTitle = [...settings.products.gift, ...settings.products.me].find(prod => prod.product.handle === (state.subscriptionType === 'me' ? state.productHandle : state.giftProductHandle))?.title

  return (
    <div className="sub-builder">

      <div id="IDFORDANNY" style={{ display: 'none' }}> { JSON.stringify(state, null, 2) } </div>

      <ul id="IDFORDANNY2" style={{ display: 'none' }} className="sub-builder-plan-list">
        <li><span>Step</span>: <span>{state.step}</span></li>
        <li><span>{ stepConfig.strings.whoLabel }</span>: <span>{ state.subscriptionType === 'gift' ? 'Gift' : 'You' }</span></li>
        <li><span>{stepConfig.strings.planLabel}</span>: <span>{productTitle ?? ''}</span></li>
        <li><span>{stepConfig.strings.grindLabel}</span>: <span>{state.subscriptionType === 'me' ? state.grindOption : state.giftGrindOption }</span></li>
        <li><span>{stepConfig.strings.quantityLabel}</span><span>: { state.quantityOption }</span></li>
        {state.subscriptionType === 'gift' && state.deliveryDate && <li><span>{stepConfig.strings.deliveryLabel}</span>: <span>{`${state.deliveryDate.getDate()}/${state.deliveryDate.getMonth() + 1}/${state.deliveryDate.getFullYear()}`}</span></li>}
      </ul>
      
      { state.step && <StepBar /> }


      {!state.step && <Who />}

      { state.step === 'roast' && !state.productHandle && (
        <Roast />
      )}

      {state.step === 'grind' && !state.grindOption && (
        <Grind />
      )}

      { state.step === 'duration' && !state.durationOption && (
        <Duration />
      )}

      { state.step === 'quantity' && !state.quantityOption && (
        <Quantity />
      )}

      { state.step === 'date' && (
        <DateStep />
      )}

      { state.step === 'routine' && (
        <Routine />
      )}
  

      { state.step === 'summary' && (
        <Summary />
      )}


    </div>
  )
};

export default SubBuilder